import request from 'tools/request'

export const getEmailTemplateList = async () => {
  const companyId = localStorage.getItem('companyId')
  const res = await request.get(`${process.env.REACT_APP_CARRIER_API_URL}emailtemplateresource/list`, {
    params: {
      companyId: companyId,
      templateTypeId: '',
    },
  })
  return res?.data
}

export const getNewUserEmailTemplateList = async () => {
  const companyId = localStorage.getItem('companyId')
  const res = await request.get(`${process.env.REACT_APP_CARRIER_API_URL}emailtemplateresource/templatetype/newuser`, {
    params: {
      companyId: companyId,
    },
  })
  return res?.data
}

export const getEmailTemplateById = async (templateTypeId: any) => {
  if (!templateTypeId) return
  const res: any = await request.get(`${process.env.REACT_APP_CARRIER_API_URL}emailtemplatetyperesource/get`, {
    params: {
      templateTypeId,
    },
  })
  return res?.data?.data[0]
}

export const getEmailTemplateTypes = async () => {
  const res = await request.post(`${process.env.REACT_APP_CARRIER_API_URL}emailtemplatetyperesource/list`)
  return res?.data
}

export const updateEmailTemplate = async (
  formPayload: any,
  emailTemplateContent: string
) => {
  const companyId = localStorage.getItem('companyId')
  const payLoad = {
    ...formPayload,
    companyId,
    emailTemplateContent,
  }
  const res = await request.post(`${process.env.REACT_APP_CARRIER_API_URL}emailtemplateresource/update`, payLoad)
  return res?.data
}

export const createEmailTemplate = async (
  formPayload: any,
  emailTemplateContent: string
) => {
  const companyId = localStorage.getItem('companyId')
  const payLoad = {
    ...formPayload,
    templateId: '',
    companyId,
    emailTemplateContent,
  }
  const res = await request.post(`${process.env.REACT_APP_CARRIER_API_URL}emailtemplateresource/add`, payLoad)
  return res?.data
}
